export default __webpack_public_path__ + "static/media/jira.16dcbdd3.svg";